/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import UserTab from './UserTab';
import UserGeneral from '../tabs/General/UserGeneral';
import UserAccounting from '../tabs/Accounting/UserAccounting';

import UserUniform from '../tabs/Uniform/UserUniform';
import UserQualification from '../tabs/Qualification/UserQualification';
import SuperAdmin from '../tabs/SuperAdmin/SuperAdmin';

import * as Constants from '../../Constant';
import axios from 'axios';

import employeeService from '../../../services/EmployeeService';

import { Plugin, Template, TemplateConnector, TemplatePlaceholder } from '@devexpress/dx-react-core';

import { getFormattedEmployeeList, getFormattedEmployeePayload, getDirtyFormValues } from '../helper/helper';
import toast from 'react-hot-toast';

export const Popup = ({
  row,
  onChange,
  onApplyChanges,
  onCancelChanges,
  open,
  userTabIndex,
  setUserTabIndex,
  vendorRecords,
  keyPayEmployeeRecords,
  selectedEmployeeToRegister,
  setSelectedEmployeeToRegister,
  selectedUserType,
  setSelectedUserType,
  approvalRequired,
  setApprovalRequired,
  selectedApprover,
  setSelectedApprover,
  portalAccess,
  setPortalAccess,
  portalAccessDialog,
  setPortalAccessDialog,
  setRows,
  rows
}) => {
  useEffect(() => {
    if (open) {
      setSelectedUserType({
        value: selectedUserType.value || row.employeeType,
        label: selectedUserType.label || row.employeeType
      });
    }
  }, [row.employeeType, setSelectedUserType, selectedUserType.label, selectedUserType.value, open]);

  useEffect(() => {
    if (open) {
      setPortalAccess(Boolean(row?.id && row.portalAccess));
    }
  }, [open, row?.id, row.portalAccess, setPortalAccess]);

  useEffect(() => {
    if (open) {
      const fetchEmployeeExtended = async () => {
        try {
          // call employeeExtended to get this user approval and show in required approval
          const result = await employeeService.getUserApprover(row.id);

          if (result.data.data) {
            const approverData = result.data.data[0];

            const userApprover = rows.filter((row) => row.id == approverData.approverId)[0];
            const selectedApprover = {
              value: userApprover.DisplayName,
              label: userApprover.DisplayName,
              id: userApprover.id
            };

            setApprovalRequired(approverData.approvalRequired);
            setSelectedApprover(selectedApprover);
            //  setPortalAccess(row?.portalAccess);
          }
        } catch (error) {
          // eslint-disable-next-line no-console, no-undef
          console.log('error', error);
        }
      };
      fetchEmployeeExtended();
    }
  }, [open, row.id, rows, setApprovalRequired, setSelectedApprover]);

  return (
    <Dialog open={open} onClose={onCancelChanges} aria-labelledby="form-dialog-title" fullWidth maxWidth="md">
      <UserTab userTabIndex={userTabIndex} setUserTabIndex={setUserTabIndex} />

      {/* General and Accounting is the content of tab  */}
      {userTabIndex === 0 && (
        <UserGeneral
          row={row}
          onChange={onChange}
          onApplyChanges={onApplyChanges}
          onCancelChanges={onCancelChanges}
          vendorRecords={vendorRecords}
          keyPayEmployeeRecords={keyPayEmployeeRecords}
          selectedEmployeeToRegister={selectedEmployeeToRegister}
          setSelectedEmployeeToRegister={setSelectedEmployeeToRegister}
          selectedUserType={selectedUserType}
          setSelectedUserType={setSelectedUserType}
          approvalRequired={approvalRequired}
          setApprovalRequired={setApprovalRequired}
          selectedApprover={selectedApprover}
          setSelectedApprover={setSelectedApprover}
          open={open}
          portalAccessDialog={portalAccessDialog}
          setPortalAccessDialog={setPortalAccessDialog}
          portalAccess={portalAccess}
          setPortalAccess={setPortalAccess}
          setRows={setRows}
          rows={rows}
        />
      )}

      {userTabIndex === 1 && <SuperAdmin row={row} onCancelChanges={onCancelChanges} />}

      {userTabIndex === 2 && (
        <UserAccounting
          row={row}
          onCancelChanges={onCancelChanges}
          setUserTabIndex={setUserTabIndex}
          vendorRecords={vendorRecords}
          keyPayEmployeeRecords={keyPayEmployeeRecords}
        />
      )}

      {userTabIndex === 3 && (
        <UserQualification
          row={row}
          onCancelChanges={onCancelChanges}
          setUserTabIndex={setUserTabIndex}
          vendorRecords={vendorRecords}
          keyPayEmployeeRecords={keyPayEmployeeRecords}
        />
      )}

      {userTabIndex === 4 && (
        <UserUniform
          row={row}
          onCancelChanges={onCancelChanges}
          setUserTabIndex={setUserTabIndex}
          vendorRecords={vendorRecords}
          keyPayEmployeeRecords={keyPayEmployeeRecords}
        />
      )}
    </Dialog>
  );
};

// eslint-disable-next-line react/display-name, react/prop-types
export const PopupEditing = React.memo(
  ({
    popupComponent: Popup,
    userTabIndex,
    setUserTabIndex,
    vendorRecords,
    keyPayEmployeeRecords,
    selectedEmployeeToRegister,
    setSelectedEmployeeToRegister,
    setRows,
    selectedUserType,
    setSelectedUserType,
    approvalRequired,
    setApprovalRequired,
    selectedApprover,
    setSelectedApprover,
    portalAccess,
    setPortalAccess,
    portalAccessDialog,
    setPortalAccessDialog,
    rows,
    editingMode,
    setEditingMode
  }) => (
    <Plugin>
      <Template name="popupEditing">
        <TemplateConnector>
          {(
            { getRowId, addedRows, editingRowIds, createRowChange, rowChanges },
            {
              changeRow,
              changeAddedRow,
              commitChangedRows,
              commitAddedRows,
              stopEditRows,
              cancelAddedRows,
              cancelChangedRows
            }
          ) => {
            const isNew = addedRows.length > 0;
            let editedRow;
            let originalRow;
            let rowId;
            if (isNew) {
              rowId = 0;
              editedRow = addedRows[rowId];
            } else {
              [rowId] = editingRowIds;
              originalRow = rows.find((row) => getRowId(row) === rowId);
              editedRow = { ...originalRow, ...rowChanges[rowId] };
            }

            const processValueChange = ({ target: { name, value } }) => {
              const changeArgs = {
                rowId,
                change: createRowChange(editedRow, value, name)
              };
              if (isNew) {
                changeAddedRow(changeArgs);
              } else {
                changeRow(changeArgs);
              }
            };

            const rowIds = isNew ? [0] : editingRowIds;
            const applyChanges = async (formValues, dirtyFields) => {
              //when new user is created
              if (isNew) {
                // once save button is clicked while adding new user
                let employeePayload = getFormattedEmployeePayload(selectedEmployeeToRegister, {
                  ...editedRow,
                  ...formValues
                });

                employeePayload = {
                  ...employeePayload,
                  type: formValues.userRole,
                  portalAccess: false,
                  approverId: selectedApprover?.id,
                  approvalRequired: approvalRequired
                };

                try {
                  const { data } = await employeeService.registerEmployee(employeePayload);
                  const formattedEmployee = getFormattedEmployeeList([data.data])[0];

                  setRows([formattedEmployee, ...rows]);
                  commitAddedRows({ rowIds });

                  // set added user in localStorage to use in accounting
                  // eslint-disable-next-line no-undef
                  localStorage.setItem('addedUser', JSON.stringify(formattedEmployee));

                  toast.success('Successfully created new user');
                  setPortalAccess(false);
                  setEditingMode(null);
                } catch (error) {
                  if (!error?.response?.data?.field) {
                    toast.error(error?.response?.data?.message || 'Could not create employee');
                  }
                  throw error;
                }
              } else {
                const changedValues = getDirtyFormValues(formValues, dirtyFields);
                if (formValues.userRole !== originalRow.userRole) changedValues.userRole = formValues.userRole;

                if (Object.keys(changedValues).length === 0) {
                  toast('No changes to save.');
                  return;
                }

                const employeePayload = {
                  // eslint-disable-next-line no-undef
                  token: localStorage.getItem('token'),
                  updateUserId: originalRow.id,
                  ...changedValues
                };

                const url = originalRow.KeyPayEmployeeId
                  ? Constants.BASE_URL + `keyPayEmployee/updateOneKeyPayEmployee/${originalRow.KeyPayEmployeeId}`
                  : Constants.BASE_URL + 'employee/updateEmployee';

                try {
                  const response = await axios.post(url, employeePayload);
                  const failedSteps = (response?.data?.steps || []).filter((step) => step.status === 'failed');
                  if (failedSteps.length) {
                    throw new Error(failedSteps.map((step) => `${step.name}: ${step.message}`).join('; '));
                  }

                  setRows(
                    rows.map((existingRow) => {
                      if (existingRow.id !== originalRow.id) return existingRow;

                      const updatedRow = { ...existingRow, ...changedValues };
                      if (changedValues.PrimaryPhone !== undefined) updatedRow.Phone = changedValues.PrimaryPhone;
                      if (changedValues.userRole !== undefined) updatedRow.userRole = changedValues.userRole;
                      if (changedValues.FirstName !== undefined || changedValues.FamilyName !== undefined) {
                        updatedRow.DisplayName = `${formValues.FirstName} ${formValues.FamilyName}`.trim();
                      }
                      return updatedRow;
                    })
                  );
                  stopEditRows({ rowIds });
                  commitChangedRows({ rowIds });
                  setEditingMode(null);
                  setSelectedEmployeeToRegister();
                  toast.success('Successfully updated user');
                } catch (error) {
                  if (!error?.response?.data?.field) {
                    toast.error(error?.response?.data?.message || error?.message || 'Could not update employee');
                  }
                  throw error;
                }
              }
            };

            const cancelChanges = () => {
              setEditingMode(null);
              if (isNew) {
                cancelAddedRows({ rowIds });
                setSelectedEmployeeToRegister();
                setSelectedUserType({ value: '', label: '' });
                setSelectedApprover({ value: '', label: '', id: '' });
                setApprovalRequired(false);
                setPortalAccess(false);
                setUserTabIndex(0);
              } else {
                stopEditRows({ rowIds });
                cancelChangedRows({ rowIds });
                setSelectedEmployeeToRegister();
                setSelectedUserType({ value: '', label: '' });
                setSelectedApprover({ value: '', label: '', id: '' });
                setApprovalRequired(false);
                setPortalAccess(false);
                setUserTabIndex(0);
              }
            };

            const open = isNew || (editingMode === 'popup' && editingRowIds.length > 0);

            return (
              <Popup
                open={open}
                row={editedRow}
                onChange={processValueChange}
                onApplyChanges={applyChanges}
                onCancelChanges={cancelChanges}
                userTabIndex={userTabIndex}
                setUserTabIndex={setUserTabIndex}
                vendorRecords={vendorRecords}
                keyPayEmployeeRecords={keyPayEmployeeRecords}
                selectedEmployeeToRegister={selectedEmployeeToRegister}
                setSelectedEmployeeToRegister={setSelectedEmployeeToRegister}
                selectedUserType={selectedUserType}
                setSelectedUserType={setSelectedUserType}
                approvalRequired={approvalRequired}
                setApprovalRequired={setApprovalRequired}
                selectedApprover={selectedApprover}
                setSelectedApprover={setSelectedApprover}
                portalAccessDialog={portalAccessDialog}
                setPortalAccessDialog={setPortalAccessDialog}
                portalAccess={portalAccess}
                setPortalAccess={setPortalAccess}
                setRows={setRows}
                rows={rows}
              />
            );
          }}
        </TemplateConnector>
      </Template>
      <Template name="root">
        <TemplatePlaceholder />
        <TemplatePlaceholder name="popupEditing" />
      </Template>
    </Plugin>
  )
);
